import { NgModule } from "@angular/core";
import { HeaderComponent } from "src/app/base/header/header.component";
import { GalleryComponent } from "src/app/base/gallery/gallery.component";
import { ScrolledHeaderDirective } from "src/app/base/header/directives/scroll-header.directive";
import { AOSDirective } from "src/app/base/directives/aos.directive";
import { RouterModule, Routes } from "@angular/router";
import { CommonModule } from "@angular/common";
import { DropDownDirective } from "./directives/drop-down.directive";
import { PageHeaderComponent } from "./page-header/page-header.component";
import { ImageCarouselComponent } from "./image-carousel/image-carousel.component";
import { AccordionComponent } from "./accordion/accordion.component";
import { NewsPostComponent } from "./news-post/news-post.component";
import { DownloadService } from "./services/download.service";

@NgModule({
  declarations: [
    HeaderComponent,
    ImageCarouselComponent,
    GalleryComponent,
    ScrolledHeaderDirective,
    NewsPostComponent,
    DropDownDirective,
    AOSDirective,
    PageHeaderComponent,
    AccordionComponent
  ],
  imports: [CommonModule, RouterModule],
  exports: [
    HeaderComponent,
    ImageCarouselComponent,
    GalleryComponent,
    ScrolledHeaderDirective,
    NewsPostComponent,
    DropDownDirective,
    AOSDirective,
    PageHeaderComponent,
    AccordionComponent
  ],
  providers: [DownloadService]
})
export class BaseModule {}
